import Vue from 'vue';
import '@/magnetarSetup.js';
//  Plugins
import vuetify from '@/plugins/vuetify';
import '@/plugins/vue-composition-api';
import './plugins/analytics';
import '@/plugins/vue-youtube-embed';
import '@/plugins/floating-vue';
import './filters';
import { sync } from 'vuex-router-sync';

import { subscribeToUser, unsubscribeToUser } from '@/store/useAuth';

import App from './App.vue';
import router from './router';
import store from './store/';

//  Globally register our recurseive context_doc component
import ContextDoc from '@/components/ContextDoc';
Vue.component('ContextDoc', ContextDoc);
import ContentBlock from '@/components/ContextDoc/ContentBlock';
Vue.component('ContentBlock', ContentBlock);

// import firebase
// import fb from './firebaseConfig';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

//  import fonts
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import { OhVueIcon, addIcons } from 'oh-vue-icons';
import * as MdIcons from 'oh-vue-icons/icons/md';
import * as BiIcons from 'oh-vue-icons/icons/bi';
import { RiLayoutColumnFill } from 'oh-vue-icons/icons';

const Md = Object.values({ ...MdIcons });
const Bi = Object.values({ ...BiIcons });
addIcons(...Md, RiLayoutColumnFill, ...Bi);

Vue.component('oh-v-icon', OhVueIcon);

import ResultNode from '@/views/Context/components/ContextSearch/ResultNode';
Vue.component('ResultNode', ResultNode);

import PageTypeIcon from '@/components/ContextDoc/PageTypeIcon';
Vue.component('PageTypeIcon', PageTypeIcon);

//import quill theme
// import 'quill/dist/quill.snow.css';

//  import and register universal components
import CIcon from '@/components/CIcon';
Vue.component('c-icon', CIcon);
import ShortcutIcon from '@/components/ShortcutIcon';
Vue.component('shortcut-icon', ShortcutIcon);

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.configureWebpack = { devtool: 'source-map' };
Vue.config.performance = true;

//  Setup sync from router to store
sync(store, router);

let app;
const auth = getAuth();
onAuthStateChanged(auth, async user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      vuetify,
      render: h => h(App),
      mounted() {
        // Prevent blank screen in Electron builds
        // this.$router.push('/');
      }
    });
  }

  if (user) {
    // store.commit('auth/setFetchingUserData', true);
    try {
      console.log(user);
      const userSubed = await subscribeToUser(user.uid);
      if (userSubed) {
        console.log('auth changed, subscribed to user, push to context');
        router.push('/context/');
      }
      // await store.dispatch('auth/subscribeToUser');
      // store.commit('auth/setFetchingUserData', false);
    } catch (e) {
      console.log(e);
      // store.commit('auth/setFetchingUserData', false);
    }
  } else {
    //store.dispatch('userContextsLite/unsubscribeToUserContextsLite');
    // useUserSummary().unsubscribe;
    unsubscribeToUser();
  }
});
